'use client';

import { useMemo } from 'react';
import { usePathname } from 'next/navigation';

export const useIsRouteGame = () => {
  const pathname = usePathname();
  const regex = /\/games\/([^\/]+)\/([^\/?]+)/;
  const isGame = useMemo(() => pathname?.match(regex), [pathname]);

  return {
    isGame,
  };
};
